import React from 'react';
import FollowButtonContainer from './discovery/feed/follow_button_container';
import { IFollowParams } from '@reverbdotcom/commons';
import { FindFavoriteProvider } from './favorites/find_favorite_context';
import { FavoriteButtonContainer } from './favorites/favorite_button_container';
import experiments from '@reverbdotcom/commons/src/experiments';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';

interface CSP2EmptyStateProps {
  heading: string;
  followParams: IFollowParams;
  feedPrompt: string
}

export function CSP2EmptyState(props: CSP2EmptyStateProps) {
  const user = useUser();
  const favoriteButtonRQLEnabled = isExperimentEnabled(user, experiments.FAVORITE_BUTTON_RQL);

  return (
    <aside className="align-center width-80 mobile-width-100 mlr-auto">
      <div className="scaling-padding-4 bg-offwhite bg--lighten">
        { favoriteButtonRQLEnabled ? (
          <FindFavoriteProvider>
            <FavoriteButtonContainer
              displayStyle="banner"
              header={props.heading}
              subtext={props.feedPrompt}
            />
          </FindFavoriteProvider>
        ) : (
          <>
            <h2 className="size-130 mobile-size-110 mb-1">
              {props.heading}
            </h2>
            <p className="scaling-mb-2">
              {props.feedPrompt}
            </p>
            <FollowButtonContainer
              withPriceFilters
              withUsedFilter
              followParams={props.followParams}
            />
          </>
        )}
      </div>
    </aside>
  );
}
